import React from 'react';

const IcHomeRetail = () => {
  return (
    <svg width='65' height='64' viewBox='0 0 65 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_9543_14354)'>
        <mask
          id='mask0_9543_14354'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='65'
          height='64'
        >
          <path d='M0.510254 3.8147e-06H64.5103V64H0.510254V3.8147e-06Z' fill='white' />
        </mask>
        <g mask='url(#mask0_9543_14354)'>
          <path
            d='M25.8228 59.3125C25.8228 61.3835 24.1438 63.0625 22.0728 63.0625C20.0018 63.0625 18.3228 61.3835 18.3228 59.3125C18.3228 57.2415 20.0018 55.5625 22.0728 55.5625C24.1438 55.5625 25.8228 57.2415 25.8228 59.3125Z'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M23.0103 59.3125C23.0103 59.8304 22.5906 60.25 22.0728 60.25C21.5549 60.25 21.1353 59.8304 21.1353 59.3125C21.1353 58.7946 21.5549 58.375 22.0728 58.375C22.5906 58.375 23.0103 58.7946 23.0103 59.3125Z'
            fill='#1D2129'
          />
          <path
            d='M55.1353 59.3125C55.1353 59.8304 54.7156 60.25 54.1978 60.25C53.6799 60.25 53.2603 59.8304 53.2603 59.3125C53.2603 58.7946 53.6799 58.375 54.1978 58.375C54.7156 58.375 55.1353 58.7946 55.1353 59.3125Z'
            fill='#1D2129'
          />
          <path
            d='M57.9478 59.3125C57.9478 61.3835 56.2688 63.0625 54.1978 63.0625C52.1268 63.0625 50.4478 61.3835 50.4478 59.3125C50.4478 57.2415 52.1268 55.5625 54.1978 55.5625C56.2688 55.5625 57.9478 57.2415 57.9478 59.3125Z'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.704 3.68128L11.052 6.33328'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M41.8853 36.8125C41.8853 38.8835 40.2063 40.5625 38.1353 40.5625H22.5678L15.5285 44.5538C14.9385 44.8878 14.5728 45.5134 14.5728 46.1875C14.5728 47.2214 15.4139 48.0625 16.4478 48.0625H57.9478C58.9833 48.0625 59.8228 48.902 59.8228 49.9375C59.8228 50.973 58.9833 51.8125 57.9478 51.8125H16.4478C13.3463 51.8125 10.8228 49.2891 10.8228 46.1875C10.8228 44.1649 11.9176 42.2888 13.6799 41.2909L19.9014 37.7634L12.5233 8.916C11.8874 6.426 9.64613 4.6875 7.07275 4.6875H3.32275C2.28725 4.6875 1.44775 3.848 1.44775 2.8125C1.44775 1.777 2.28725 0.937503 3.32275 0.937503H7.07275C11.3611 0.937503 15.0964 3.8365 16.1565 7.9875L23.5288 36.8125H52.4924C55.0623 36.8125 57.3054 35.0708 57.942 32.581L63.5728 10.5625H16.815'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M27.5452 19.3125H19.053'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M61.3352 19.3125H31.2952'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.2908 28.0625H59.0974'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M50.2026 36.8125L54.23 10.5625'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M43.5454 36.8125L44.8875 10.5625'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M36.8882 36.8125L35.5449 10.5625'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M30.231 36.8125L26.2024 10.5625'
            stroke='#1D2129'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_9543_14354'>
          <rect width='64' height='64' fill='white' transform='translate(0.510254)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IcHomeRetail;
